import {BooleanParam, useQueryParam} from 'use-query-params';

import useAuth from 'src/hooks/useAuth';
import featureFlags from 'src/lib/featureFlags';

const PREVIEW_PARAM = 'h5Preview';

/**
 * Whether the dashboard is previewing H5 sections that are not yet customer-visible. The state
 * lives in the URL so a preview is a link an internal user can hand to someone else. `allowed` is
 * whether this user may preview at all; for anyone else the param is ignored.
 */
export function useH5Preview(): {
  allowed: boolean;
  enabled: boolean;
  setEnabled: (on: boolean) => void;
} {
  const auth = useAuth();
  const allowed = featureFlags.H5_PREVIEW(auth.status === 'logged in' ? auth.userProfile : null);
  const [param, setParam] = useQueryParam(PREVIEW_PARAM, BooleanParam);
  return {
    allowed,
    enabled: allowed && !!param,
    setEnabled: (on: boolean) => setParam(on ? true : undefined),
  };
}
